import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

export default class RepliedToSupportTicket extends Notification {
  icon() {
    return 'fas fa-reply';
  }

  href() {
    const notification = this.attrs.notification;

    const data = notification.content() || {};

    // Ticket ID not attached
    // Send by older versions of extension
    if (!data.ticket_id) {
      return app.route('ticketsOverview');
    }

    return app.route('ticketsView', { id: data.ticket_id });
  }

  content() {
    return app.translator.trans('v17development-flarum-support.forum.notifications.replied_to_ticket.content', {
      replier_display_name: this.attrs.notification.fromUser().displayName(),
      ticket_id: this.attrs.notification.subject().id(),
    });
  }
}
